/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AppWithCharCount } from '../../models/app-with-char-count';

export interface AppsControllerFindAllWithEnglishCharacterCount$Params {
}

export function appsControllerFindAllWithEnglishCharacterCount(http: HttpClient, rootUrl: string, params?: AppsControllerFindAllWithEnglishCharacterCount$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AppWithCharCount>>> {
  const rb = new RequestBuilder(rootUrl, appsControllerFindAllWithEnglishCharacterCount.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AppWithCharCount>>;
    })
  );
}

appsControllerFindAllWithEnglishCharacterCount.PATH = '/apps/with-english-character-count';
